module.exports = __webpack_public_path__ + "static/media/Products (6).78935e2a.jpg";